import { selectProjectState } from 'projectRedux/store';
import { projectExtraComponentAdapter } from '../adapters/projectExtraComponentAdapter';

export const {
  selectAll: selectAllProjectExtraComponents,
  selectById: selectProjectExtraComponentById,
  selectEntities: selectProjectExtraComponentEntities,
} = projectExtraComponentAdapter.getSelectors((state) => selectProjectState(state).projectExtraComponents);
